module.exports = __webpack_public_path__ + "img/paishui.42d994ae.png";